import { render, staticRenderFns } from "./ClaimAttachFile.vue?vue&type=template&id=66b149d5&"
import script from "./ClaimAttachFile.vue?vue&type=script&lang=js&"
export * from "./ClaimAttachFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports